import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

export type FastServicePackageSelect = {
	OsobniCis?: string;
	PracovnikOzn?: string;
	ProvozovnaId?: number;
	PracovnikId?: number;
	PracovnikText?: string;
	ProvozovnaIdText?: number;
};

class ServicePackageProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	getPracovnikByPersonCard(personcardId: number) {
		return this.fetch(`${this.apiPath}GetPracovnikByPersonCard`, { personcardId });
	}
}

export const apiProvider = new ServicePackageProvider();
